export default (url: string): boolean => /^blob:https?:\/\//.test(url);
